module.exports = __webpack_public_path__ + "static/img/kid-2.6235cf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kid-2.png
// module id = Ygb+
// module chunks = 0